import { render, staticRenderFns } from "./AddProfileCompetenciesDialog.vue?vue&type=template&id=4dc58315"
import script from "./AddProfileCompetenciesDialog.vue?vue&type=script&lang=js"
export * from "./AddProfileCompetenciesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports